export default "__VITE_ASSET__B2drpt2h__"